import React, {
  InputHTMLAttributes,
  useCallback,
  useMemo,
  useState,
} from 'react';

import { useSelector } from 'react-redux';

import { IState } from 'store';
import {
  IFilterCategoryThreeProps,
  IShowCaseProps,
} from 'store/modules/showcase';
import { objectIsEmpty } from 'utils/objectEmpty';

import InputCheckbox from 'components/common/Input/InputCheckbox';

import Checkbox from '..';

import * as S from './styles';

interface ICheckBoxProps extends IFilterCategoryThreeProps {
  value: number;
  label: React.ReactNode;
}

interface ICheckboxItemProps extends InputHTMLAttributes<HTMLInputElement> {
  type: 'category' | 'brand';
  option: ICheckBoxProps;
  handleSelect(id: Array<number>, remove: boolean): void;
}

const CheckboxItem: React.FC<ICheckboxItemProps> = ({
  type,
  option,
  handleSelect,
}) => {
  const showcase = useSelector<IState, IShowCaseProps>(
    state => state.showcase.showcase,
  );
  const ca = useMemo(() => {
    if (objectIsEmpty(showcase)) return [];
    return showcase.filtros.opcoesSelecionadas.ca;
  }, [showcase]);

  const [childrenDropped, setChildrenDropped] = useState(false);

  const handleSelectCategory = useCallback(() => {
    const ids = [option.id];

    if (option.filhos?.length) {
      option.filhos.forEach(children1 => {
        ids.push(children1.id);

        if (children1.filhos?.length) {
          children1.filhos.forEach(children2 => {
            ids.push(children2.id);

            if (children2.filhos?.length) {
              children2.filhos.forEach(children3 => {
                ids.push(children3.id);

                if (children3.filhos?.length) {
                  children3.filhos.forEach(children4 => {
                    ids.push(children4.id);
                  });
                }
              });
            }
          });
        }
      });
    }

    handleSelect(
      ids,
      ca.some(item => item === option.id),
    );
  }, [option, ca, handleSelect]);

  return (
    <S.Container>
      <div className="item">
        <label htmlFor={`${option.id}`} className="checkbox-item-check">
          <InputCheckbox
            name="checkbox_item"
            checked={ca.some(item => item === option.id)}
            value={option.value}
            type="checkbox"
            id={`${option.id}`}
            onChange={handleSelectCategory}
          />
          <p onClick={handleSelectCategory}>{option.label}</p>
        </label>

        {!!option.filhos?.length &&
          (childrenDropped ? (
            <span
              className="chevron-icon up black"
              title="Esconder"
              onClick={() => setChildrenDropped(false)}
            />
          ) : (
            <span
              className="chevron-icon down black"
              title="Mostrar"
              onClick={() => setChildrenDropped(true)}
            />
          ))}
      </div>

      {childrenDropped && (
        <div className="childrens-box">
          {childrenDropped && (
            <Checkbox
              type={type}
              items={option.filhos}
              handleSelect={handleSelect}
            />
          )}
        </div>
      )}
    </S.Container>
  );
};

export default CheckboxItem;
